export default __webpack_public_path__ + "static/rovo-actions-dark-9a1c64af3afa158267acd98695b50682.png";